import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { IStyles, mediaCSS, palette } from '../../../../theme'

const catalogTemplateDisplaysStyles: IStyles = {
    status: {
        position: 'relative',
        ...grid.p_micro,
        ...item.rounded_full_mini,
        ...item.white,
        ...grid.mr_mini,
    },
    statusLocked: {
        backgroundColor: palette.neutral[700],
    },
    lockBadge: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
        display: 'flex',
        lineHeight: 0,
        filter: 'drop-shadow(0 0 1px rgba(0, 0, 0, 0.45))',
    },
    name: {
        ...grid.w100,
        ...grid.row,
        ...grid.noWrap,
        ...grid.normalCenter,
        textAlign: 'left',
    },
    listStatus: {
        marginRight: 10,
    },
    statusWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        minWidth: 180,
        textAlign: 'center',
        height: 55,
    },
    mediaCellClassName: {
        [mediaCSS.tab]: {
            ...grid.col4,
        },
        [mediaCSS.tabMini]: {
            width: '50% !important',
        },
    },
    description: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: 500,
    },
}

addStyles(catalogTemplateDisplaysStyles)
export default catalogTemplateDisplaysStyles
